export enum LanguageProficiency {
  beginner = 'Beginner',
  conversational = 'Conversational',
  proficient = 'Proficient',
  fluent = 'Fluent',
  bilingual = 'Bilingual',
  native = 'Native'
}
